import { GoldenSourceHelper } from "../../app/Switch_Core_React_Standards";

/**
 * 🎯 DAG-aware hierarchy rules, backed by Corp.Z_01_06_CorporateEntity_Ownership
 * (many-to-many — a child can have more than one parent, i.e. co-ownership).
 * `edges` is the full active link list from fetchOwnershipLinks(); `draft` is
 * an array of {parentEntityId, childEntityId} pairs staged but not yet saved
 * in the current ManageStructure session — both are walked together so an
 * in-flight edit can't create a cycle before it's even saved.
 */
export class CorporateHierarchyRules {
  static _parentsOf(entityId, edges, draft) {
    const parents = [];
    edges.forEach((e) => {
      if (GoldenSourceHelper.get(e, "ChildEntityId") === entityId) {
        parents.push(GoldenSourceHelper.get(e, "ParentEntityId"));
      }
    });
    draft.forEach((d) => {
      if (d.childEntityId === entityId) parents.push(d.parentEntityId);
    });
    return parents;
  }

  static canBeRoot(entityId, edges, draft) {
    if (!entityId) return false;
    return CorporateHierarchyRules._parentsOf(entityId, edges, draft).length === 0;
  }

  /**
   * Would linking childId under newParentId create a cycle? True if
   * newParentId === childId, or if childId is already an ancestor of
   * newParentId along ANY path (walking every parent an entity has, not
   * just one).
   */
  static wouldCreateCycle(childId, newParentId, edges, draft) {
    if (!newParentId) return false;
    if (newParentId === childId) return true;

    const visited = new Set();
    let frontier = [newParentId];

    while (frontier.length > 0) {
      const next = [];
      for (const current of frontier) {
        if (visited.has(current)) continue;
        visited.add(current);

        const parents = CorporateHierarchyRules._parentsOf(current, edges, draft);
        for (const p of parents) {
          if (p === childId) return true;
          if (!visited.has(p)) next.push(p);
        }
      }
      frontier = next;
    }
    return false;
  }
}
